import React, {type JSX} from 'react';
import {Typography} from '@mui/material';

type Props = {
  title?: string;
  description?: string;
  isError?: boolean;
};

function Description({
  title,
  description,
  isError = false,
}: Readonly<Props>): JSX.Element {
  return (
    <>
      <Typography variant="h5" color={isError ? 'errorMain' : 'commonBlack'}>
        {title}
      </Typography>
      {description ? (
        <Typography
          variant="body5"
          fontStyle="italic"
          color="textSecondary"
          component="p"
          sx={{marginBottom: '16px'}}
        >
          {description}
        </Typography>
      ) : null}
    </>
  );
}

export default Description;
